import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from 'client/i18n/hooks/useT';
import { MENU_MODE } from '../../user';
import { LoginContainer } from '../LoginContainer';
import RequestResetPasswordContainer from '../RequestResetPasswordContainer';
import RequestResetPasswordConfirmationContainer from '../RequestResetPasswordConfirmationContainer';
import {
  Wrapper,
  OverlayWrapper,
  Overlay,
  OverlayHeaderSection,
  OverlayContent,
  SwitchToAnchor,
} from '../ImportOnboarding/styles';
import {
  SwitchToAnchorOverrideCSS,
  Header1,
  Header2,
  Header3,
  Paragraph,
  OverlayOverrideCSS,
} from './styles';
import { useCsrfToken } from '../../hooks/useCsrfToken';
import { useCurrentUserCtx } from '../../contexts/CurrentUser';

export function LoginPage({ menuMode, feedUrl }) {
  const { fetchCurrentUser } = useCurrentUserCtx();
  const { csrfToken } = useCsrfToken();
  const t = useT();

  return (
    <Wrapper>
      <SwitchToAnchor className={SwitchToAnchorOverrideCSS}>
        <Header2>
          {t(
            'LoginPage.WelcomeToAnchorHeader',
            'Welcome back to Anchor',
            'Login page welcome header'
          )}
        </Header2>
        <Header3>
          {t(
            'LoginPage.FeaturesHeader',
            'Free hosting, automatic distribution, easy monetization.',
            'Login page Anchor features message'
          )}{' '}
        </Header3>
      </SwitchToAnchor>
      <OverlayWrapper>
        <Overlay className={OverlayOverrideCSS}>
          <OverlayHeaderSection>
            <Header1>
              {t('LoginPage.LoginHeader', 'Log in', 'Log in header')}
            </Header1>
            <Paragraph>
              {t(
                'Login.SignupMessage',
                "Don't have an account? {signupLink} instead.",
                'Login page sign up message',
                {
                  signupLink: (
                    <Link data-cy="signUpLink" to="/signup">
                      {t('Link.Signup', 'Sign up', 'Sign up link text')}
                    </Link>
                  ),
                }
              )}
            </Paragraph>
          </OverlayHeaderSection>
          <OverlayContent>
            {menuMode === MENU_MODE.LOGIN && (
              <LoginContainer
                feedUrl={feedUrl}
                showSignUp={false}
                csrfToken={csrfToken}
                loginCallback={() => {
                  fetchCurrentUser();
                }}
              />
            )}
            {menuMode === MENU_MODE.REQUEST_RESET_PASSWORD && (
              <RequestResetPasswordContainer />
            )}
            {menuMode === MENU_MODE.REQUEST_RESET_PASSWORD_CONFIRMATION && (
              <RequestResetPasswordConfirmationContainer />
            )}
          </OverlayContent>
        </Overlay>
      </OverlayWrapper>
    </Wrapper>
  );
}
